import { deleteWaiver } from "../../api/historyService";

export const useDeleteWaiver = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteWaiver(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete waiver:", error);
            throw error;
        }
    };

    return { remove };
};